import * as tslib_1 from "tslib";
import Vue from 'vue';
import '@/lib/abp/abp.axios';
import '@/lib/abp/abp.notify';
import '@/lib/abp/abp.message';
import '@/lib/abp/abp.ui';
import SignalRAspNetCoreHelper from './lib/SignalRAspNetCoreHelper';
import store from './store/index';
import { router } from './router/index';
import App from './App.vue';
import { StartUp } from '@/lib/startup';
import { shim } from 'promise.prototype.finally';
import Vant from 'vant';
import 'vant/lib/index.css';
import Lazyload from "vant/es/lazyload";
import "vant/es/lazyload/style/index.js";
import SignCanvas from 'sign-canvas';
import moment from 'moment'; // 导入文件
// options 为可选参数，无则不传
Vue.use(Lazyload);
Vue.use(Vant);
Vue.use(SignCanvas);
Vue.prototype.$moment = moment;
shim();
Vue.config.productionTip = false;
if (!abp.utils.getCookieValue('Abp.Localization.CultureName')) {
    var language = navigator.language;
    abp.utils.setCookieValue('Abp.Localization.CultureName', language, new Date(new Date().getTime() + 5 * 365 * 86400000), abp.appPath);
}
Vue.filter('formatDate', function (time, type) {
    if (type === 1) {
        return moment(time).format('YYYY-MM-DD');
    }
    return moment(time).format('YYYY-MM-DD HH:mm');
});
abp.ui.setBusy();
// StartUp().then(() => {
var vue = new Vue({
    router: router,
    store: store,
    render: function (h) { return h(App); },
    data: {
        currentPageName: ''
    },
    mounted: function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        StartUp();
                        this.currentPageName = this.$route.name;
                        return [4 /*yield*/, this.$store.dispatch({ type: 'session/init' })];
                    case 1:
                        _a.sent();
                        if (!!this.$store.state.session.user && this.$store.state.session.application.features.SignalR) {
                            if (this.$store.state.session.application.features['SignalR.AspNetCore']) {
                                SignalRAspNetCoreHelper.initSignalR();
                            }
                        }
                        this.$store.commit('app/initCachepage');
                        return [2 /*return*/];
                }
            });
        });
    },
    created: function () {
    },
}).$mount('#app');
// abp.ui.clearBusy();
// }).catch((error) => {
//     abp.message.error('应用初始化数据获取失败！');
// });
